/**
 * TroubleshootingTab — Server status and local alerts.
 *
 * Two pp-section cards:
 *   1. "Server Status" (Inovonics only) — MQTT queue status table
 *   2. "Local Alerts" — Interrogate button + alerts table
 */

import { convertIsoToLocal, convertIsoUTCToLocal } from '../../../../libs.jsx';

/* mq.create_time is stored in UTC, so it is shown at the campus tz_offset (tzOffset);
   last_reboot_date is already local. */
const TroubleshootingTab = ({ mqData, localAlerts, interfaceId, tzOffset, onInterrogate, editRights }) => {
  const isInovonics = interfaceId === 3;
  const mq = mqData?.length > 0 ? mqData[0] : null;

  return (
    <>
      {/* Server Status — only for Inovonics (interfaceId 3) */}
      {isInovonics && mq && (
        <div className="pp-section">
          <div className="pp-section__header">
            <h3 className="pp-section__title">Server Status</h3>
          </div>
          <div className="pp-section__body">
            <div className="pp-field-grid">
              <div className="pp-field">
                <span className="pp-field__label">Queue Count</span>
                <span className="pp-field__value">{mq.queue_count ?? '—'}</span>
              </div>
              <div className="pp-field">
                <span className="pp-field__label">Status</span>
                <span className="pp-field__value">{mq.status ?? '—'}</span>
              </div>
              <div className="pp-field">
                <span className="pp-field__label">Last Updated</span>
                <span className="pp-field__value">
                  {mq.create_time ? convertIsoUTCToLocal(mq.create_time, Number(tzOffset) || 0) : '—'}
                </span>
              </div>
              <div className="pp-field">
                <span className="pp-field__label">Uptime (Hours)</span>
                <span className="pp-field__value">{mq.uptime_hrs ?? '—'}</span>
              </div>
              <div className="pp-field">
                <span className="pp-field__label">Last Reboot</span>
                <span className="pp-field__value">
                  {mq.last_reboot_date ? convertIsoToLocal(mq.last_reboot_date) : '—'}
                </span>
              </div>
              <div className="pp-field">
                <span className="pp-field__label">Active Alarms</span>
                <span className="pp-field__value">{mq.count_active_alarms ?? '—'}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Local Alerts */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Local Alerts</h3>
          <div className="pp-section__actions">
            {editRights && (
              <button
                className="dp-btn dp-btn--secondary dp-btn--sm"
                onClick={onInterrogate}
              >
                Interrogate Server
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body pp-section__body--flush">
          {(!localAlerts || localAlerts.length === 0) ? (
            <div className="dp-empty" style={{ padding: 'var(--space-8) var(--space-4)' }}>
              <p className="dp-empty__title">No active alerts</p>
              <p className="dp-empty__text">
                Use the Interrogate button to query the server for current alerts.
              </p>
            </div>
          ) : (
            <div className="dp-table-wrap">
              <table className="dp-table">
                <thead className="dp-thead">
                  <tr>
                    <th className="dp-th">Event Time</th>
                    <th className="dp-th">Category</th>
                    <th className="dp-th">Type</th>
                    <th className="dp-th">Area</th>
                    <th className="dp-th">Device</th>
                    <th className="dp-th">Serial</th>
                  </tr>
                </thead>
                <tbody>
                  {localAlerts.map((alert, idx) => (
                    <tr key={idx} className="dp-tr">
                      <td className="dp-td">
                        <span className="dp-cell-text">
                          {alert.event_time ? convertIsoToLocal(alert.event_time) : '—'}
                        </span>
                      </td>
                      <td className="dp-td">
                        <span className="dp-cell-text">{alert.event_category_name || '—'}</span>
                      </td>
                      <td className="dp-td">
                        <span className="dp-cell-text">{alert.event_type_name || '—'}</span>
                      </td>
                      <td className="dp-td">
                        <span className="dp-cell-text">{alert.area_name || '—'}</span>
                      </td>
                      <td className="dp-td">
                        <span className="dp-cell-text">{alert.device_name || '—'}</span>
                      </td>
                      <td className="dp-td">
                        <span className="dp-cell-text dp-cell-text--muted">{alert.serial_number || '—'}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TroubleshootingTab;
